var _path, _path2, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon-name": "edit-user-6",
    "data-style": "line-color",
    icon_origin_id: 24345,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Line Color",
    id: "edit-user-6",
    className: "icon line-color",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "rgb(16, 47, 116)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none",
    d: "M17,9.27A2.44,2.44,0,0,0,17,9a6,6,0,1,0-6.44,6",
    id: "primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(16, 47, 116)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9,21c-4.45-.37-6-2-6-2V18a5,5,0,0,1,3.49-4.75",
    "data-name": "primary",
    id: "primary"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "rgb(19, 180, 196)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    y2: 13,
    x2: 21,
    y1: 13,
    x1: 14,
    id: "secondary"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "rgb(19, 180, 196)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    y2: 17,
    x2: 21,
    y1: 17,
    x1: 14,
    id: "secondary"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "rgb(19, 180, 196)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    y2: 21,
    x2: 21,
    y1: 21,
    x1: 14,
    id: "secondary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e8fda38f3bf1072d8e6948b6ced9b9f5.svg";
export { ForwardRef as ReactComponent };